<template>
  <el-dialog
  :visible="visible"
  :fullscreen="true"
  :close-on-press-escape="false"
  :show-close="false"
  append-to-body
  center
  v-loading.fullscreen.lock="fullScreenLoading"
  @open="open">
    <span slot="title" class="dialog-header">
      <span  class="title" >Conciliation de l'inventaire</span>
    </span>
    <el-divider/>
    <el-row v-if="fileUploaded === false" justify="center" style="text-align:center;margin-top:40px;">
      <el-col class="formContainer" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <el-upload
          drag
          :action="postAction"
          :headers="getHeaders()"
          :before-upload="beforeUpload"
          :on-success="fileUploadedSuccess"
          :file-list="files">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">Déposer les fichiers ici ou <em>cliquez pour envoyer</em></div>
          <div class="el-upload__tip" slot="tip">Fichiers Excel avec une taille inférieure à 500kb</div>
        </el-upload>
      </el-col>
    </el-row>
    <el-row v-else>
      <div v-if="reconciliation.length === 0" class="text-center">
        <span><h2>Félicitations, votre inventaire ne nécessite aucune conciliation car il est à jour!</h2></span>
      </div>
      <div v-else>
        <p>Nombre de ligne de produit dans le fichier : {{reconciliation.length}}</p>
        <p>Nombre de ligne de produit pouvant être concilié : {{nbGoodLines}}</p>
        <p>Nombre de ligne de produit ne pouvant pas être concilié : {{nbBadLines}}</p>
      
        <el-collapse v-model="activeNames" v-if="reconciliation.length > 0" >
          <el-collapse-item title="Lignes de produit conciliées" name="1">
            <reconciliationTable @openProduct="openProductDrawer" :data="goodLines" error="warning" :selection="true" @selectionChanged="affectSelectedReconciliation" emptyText="Aucune ligne à concilier"></reconciliationTable>
          </el-collapse-item>
          <el-collapse-item title="Lignes de produit non conciliées" name="2">
          <reconciliationTable :data="badLines" error="error" emptyText="Aucune ligne"></reconciliationTable>
          </el-collapse-item>
        </el-collapse>
      </div>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">Annuler</el-button>
      <el-button :disabled="nbGoodLines==0" type="primary" @click="reconcile">Concilier</el-button>
    </span>
    <ProductDetailDrawer
      :puid="puid"
      direction="ltr"
      :visible="productDetailDrawerVisible"
      @close="closeProductDetailDrawer" />
  </el-dialog>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import adjustmentAPI from '@/services/API/adjustment'
import itemAPI from '@/services/API/items'
import reconciliationTable from './reconciliation-table'
import ProductDetailDrawer from '@/views/pages/inventory/components/product-detail-drawer'

export default {
  name: 'Inventory-Conciliation',
	props: {
    inventory_id : {
      type : Number,
      require : true
    },
    inventoryName : {
      type : String,
      require:true
    },
    visible : Boolean,

	},
  data() {
    return {
      puid: null,
      productDetailDrawerVisible: false,
      fullScreenLoading : false,
      files : [],
      reconciliation : [],
      selectedReconciliation : [],
      fileUploaded: false,
      reason : null,
      mode : 0,
      activeNames: ['1', '2'],
    };
  },components: {
    reconciliationTable,
    ProductDetailDrawer
  },
	methods: {
    openProductDrawer(puid){
      this.puid = puid;
      this.productDetailDrawerVisible = true;
    },
    closeProductDetailDrawer(){
      this.productDetailDrawerVisible = false;
    },
    affectSelectedReconciliation(selection){
      this.selectedReconciliation=selection;
    },
    open(){
      this.fullScreenLoading=true;
      adjustmentAPI.fetchAdjustmentReasons({code:'RECONCILE'})
        .then(reasons=>{
          this.reason = reasons[0];
          this.fullScreenLoading=false;
        })
    },
    beforeUpload(){
      this.fullScreenLoading=true;
    },
    fileUploadedSuccess(response, file, fileList){
      this.fullScreenLoading=false;
      this.reconciliation = response;
      this.fileUploaded = true;
    },
    reset(){
      this.files = [];
      this.reconciliation = [];
      this.activeNames=['1','2'];
    },
    close(){
      this.$emit('close');
      this.fileUploaded = false;
      this.reset();
    },
    postAdjustment(){
      // let itemsToReconcile =[];
      // _.forEach(this.goodLines, i=>{
      //   if(i.diff!=0){
      //     itemsToReconcile.push(i);
      //   }
      // })
      return adjustmentAPI.postAdjustment({inventory_id:this.inventory_id,mode:this.mode,effective_date:new Date(), reason:this.reason, items:this.selectedReconciliation})
    },
    updateItems(){
      let itemsToUpdate =[];
      _.forEach(this.selectedReconciliation, l=>{
        if(l.item!=null && _.keys(l.item).length>2){
          itemsToUpdate.push(l.item);
        }
      })
      if(itemsToUpdate.length>0){
        return itemAPI.updateItems(itemsToUpdate);
      }else{
        return Promise.resolve();
      }

    },
    reconcile(){
      this.fullScreenLoading=true;
      return Promise.all([this.postAdjustment(), this.updateItems()])
        .then(()=>{
          this.fullScreenLoading=false;
          this.invalidateStockItems();
          this.$message({
            message: 'Conciliation effectuée avec succès!',
            type: 'success'
          });
          this.close();
        }).catch(err=>{
          this.fullScreenLoading=false;
          this.$message({
            message: 'Une erreur est survenue lors de la conciliation. Veuillez réessayer plus tard. ' + err,
            type: 'error'
          });

        })
    },
    getHeaders(){
      var headers = {};
      headers.Authorization = localStorage.getItem('access-token')
      return headers;
    },
    ...mapActions('stockItems',['invalidateStockItems'])
	},
	computed: {
    postAction(){
      return process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/inventories/"+this.inventory_id+"/reconciliation-files";
    },
    nbGoodLines(){
      let goodLines = 0;
      _.forEach(this.reconciliation, i=>{if(i.reconcile)goodLines++;})
      return goodLines;
    },
    nbBadLines(){
      return this.reconciliation.length-this.nbGoodLines;
    },
    goodLines(){
      let goodLines=[];
      _.forEach(this.reconciliation, i=>{if(i.reconcile)goodLines.push(i);})
      return goodLines;
    },
    badLines(){
      let badLines=[];
      _.forEach(this.reconciliation, i=>{if(i.reconcile==false)badLines.push(i);})
      return badLines;
    }
	},
  created(){

  }
}
</script>
<style lang="scss" scoped>
@import '../../../../../assets/scss/_variables';


.dialog-footer{
  position: fixed;
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: #f3f7fa;
  height:50px;
  margin-left:-20px;
  padding-top:10px;
  border-top:1px solid #E4E7ED
}

.title {
	font-size : 1.8em;
	font-weight:bold;

}


.el-card__body, .el-card{
	position:relative;
}

.dotted-card:hover{
	cursor:pointer;
	color: #4A596A;
}

@media (max-width: 1024px) {


}

</style>
